import React, { useState } from 'react'
import { Alert, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button } from '@mui/material'
import { Box } from '@mui/system'
import authProvider from '../../utils/authProvider'
import { v4 as uuidv4 } from 'uuid'

const CreateNoteDialog = ({ open, onClose, onCreate }) => {
  const [noteContent, setNoteContent] = useState(null)

  const handleClick = async () => {
    const { email } = await authProvider.getIdentity()
    const newNote = {
      created_at: new Date().toISOString(),
      content: noteContent,
      created_by: email,
      id: uuidv4(),
    }
    setNoteContent(null)
    onCreate(newNote)
  }

  return (
    <Box>
      <Dialog open={open} onClose={onClose} fullWidth>
        <DialogTitle>Add Note</DialogTitle>
        <DialogContent>
          <Alert severity="info">To Save added notes, click save Property</Alert>
          <TextField
            fullWidth
            margin="dense"
            label="Note"
            type="text"
            multiline
            rows={3}
            value={noteContent}
            onChange={(event) => setNoteContent(event.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={handleClick}>Add</Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}

export default CreateNoteDialog
